import {
	AuMeasurementStatuses,
	AVAILABLE_USER_ROLES,
	SensorStatusesDescription,
	SystemRunStatuses,
} from './au-enums';

export const SystemRunDescriptionMap = {
	[SystemRunStatuses.running]: SensorStatusesDescription.running,
	[SystemRunStatuses.notRunning]: SensorStatusesDescription.notRunning,
	[SystemRunStatuses.noStatus]: SensorStatusesDescription.noData,
	[SystemRunStatuses.analyzing]: SensorStatusesDescription.analyzing,
};

export const CssClassStatusMap = {
	[AuMeasurementStatuses.GOOD]: 'good',
	[AuMeasurementStatuses.NORMAL]: 'good',
	[AuMeasurementStatuses.WARNING]: 'warning',
	[AuMeasurementStatuses.OK]: 'warning',
	[AuMeasurementStatuses.BAD]: 'bad',
	[AuMeasurementStatuses.POOR]: 'bad',
	[AuMeasurementStatuses.CRITICAL]: 'bad',
};

export const SingleTabMobileHeaders = {
	energy: 'Energy Consumption',
	comfort: 'Comfort',
	tech_status: 'Tech.Status',
};

export const ADMIN_ROLES = [AVAILABLE_USER_ROLES.ADMIN, AVAILABLE_USER_ROLES.SUPER_ADMIN];

export const ORGANIZATION_TYPES = {
	admin: 'Admin',
	propertyManager: 'Property Manager',
	facilityManager: 'Facility Manager',
	tenant: 'Tenant',
	service: 'Service',
};

export const ADD_SENSOR_DATA_STORAGE_KEY = 'au-new-sensor-data-temp';
export const ADD_SENSOR_CREATION_STEP_KEY = 'au-new-sensor-form-step';
export const SENSOR_SIGNAL_STRENGTH_THRESHOLD = 45;
